Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


Voronoi=function(_React$Component){_inherits(Voronoi,_React$Component);function Voronoi(){_classCallCheck(this,Voronoi);return _possibleConstructorReturn(this,(Voronoi.__proto__||Object.getPrototypeOf(Voronoi)).apply(this,arguments));}_createClass(Voronoi,[{key:"componentWillMount",value:function componentWillMount()

















{var _calculateAttributes=
this.calculateAttributes(this.props),style=_calculateAttributes.style,circle=_calculateAttributes.circle,voronoi=_calculateAttributes.voronoi;
this.style=style;
this.circle=circle;
this.voronoi=voronoi;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _calculateAttributes2=
this.calculateAttributes(nextProps),style=_calculateAttributes2.style,circle=_calculateAttributes2.circle,voronoi=_calculateAttributes2.voronoi;
if(circle!==this.circle||voronoi!==this.voronoi||!(0,_isEqual3.default)(style,this.style)){
this.style=style;
this.circle=circle;
this.voronoi=voronoi;
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var
style=props.style,datum=props.datum,active=props.active;
return{
style:_helpers2.default.evaluateStyle(style,datum,active),
circle:this.getCirclePath(props),
voronoi:this.getVoronoiPath(props)};

}},{key:"getVoronoiPath",value:function getVoronoiPath(

props){var
polygon=props.polygon;
return Array.isArray(polygon)&&polygon.length?"M "+
props.polygon.join("L")+" Z":"";
}},{key:"getCirclePath",value:function getCirclePath(

props){
if(!props.size){
return null;
}var
x=props.x,y=props.y,datum=props.datum,active=props.active;
var size=_helpers2.default.evaluateProp(props.size,datum,active);
return"M "+x+", "+y+" m "+-size+", 0\n      a "+
size+", "+size+" 0 1,0 "+size*2+",0\n      a "+
size+", "+size+" 0 1,0 "+-size*2+",0";
}},{key:"renderPoint",value:function renderPoint(


paths,style,events){
var clipId=paths.circle&&"clipPath-"+Math.random();
var clipPath=paths.circle?"url(#"+clipId+")":undefined;var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
var voronoiPath=
_react2.default.createElement("path",_extends({
d:paths.circle||paths.voronoi,
className:className,
clipPath:clipPath,
style:style,
role:role||"presentation",
shapeRendering:shapeRendering||"auto"},
events));


return paths.circle?

_react2.default.createElement("g",null,
_react2.default.createElement("defs",null,
_react2.default.createElement("clipPath",{id:clipId},
_react2.default.createElement("path",{d:paths.voronoi,className:className}))),


voronoiPath):


voronoiPath;
}},{key:"render",value:function render()

{
var paths={
circle:this.circle,
voronoi:this.voronoi};

return this.renderPoint(paths,this.style,this.props.events);
}}]);return Voronoi;}(_react2.default.Component);Voronoi.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,datum:_react.PropTypes.object,data:_react.PropTypes.array,events:_react.PropTypes.object,index:_react.PropTypes.number,polygon:_react.PropTypes.array,scale:_react.PropTypes.object,size:_react.PropTypes.number,style:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number,shapeRendering:_react.PropTypes.string,role:_react.PropTypes.string};exports.default=Voronoi;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/voronoi.js
// module id = 1383
// module chunks = 0